import useCloudinaryData from "../../../Common/hooks/useCloudinaryData";
import { getTrackerHelmetPath } from "../../../Common/utils/cloudinary";
import Media from "../../media";

const TrackerHelmet = () => {
  const { configData, cloudinaryBase, envVersion, currentSeasonYear } =
    useCloudinaryData();

  const flagImagePath = getTrackerHelmetPath(
    configData,
    cloudinaryBase,
    envVersion,
    currentSeasonYear
  );
  return <Media imgSrc={flagImagePath} imgAlt="Tracker Checkboard Flag" />;
};

export default TrackerHelmet;
